import { Component, ChangeDetectionStrategy, ViewEncapsulation, input, booleanAttribute } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'tran-unauthorized',
    templateUrl: './unauthorized.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
    encapsulation: ViewEncapsulation.None
})
export class UnauthorizedComponent {
    public readonly management = input(false, { transform: booleanAttribute });
}
